import { Skeleton, TableBody, TableHead, TableRow } from '@mui/material';
import { StyledHeaderCell, StyledTable, StyledTableCell, StyledTableRow } from './NsnTable';

export const NsnSummarySkeleton = () => {
  return (
    <StyledTable size='small'>
      <TableHead>
        <TableRow>
          <StyledHeaderCell sx={{ width: '17.5%' }}>NSN</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '32.5%' }}>Description</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '90px' }}>Assign Date</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '150px' }}>End Item Description</StyledHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <StyledTableRow>
          <StyledTableCell sx={{ width: '17.5%' }}>
            <Skeleton variant='text' width={120} height={16} />
          </StyledTableCell>
          <StyledTableCell sx={{ width: '32.5%' }}>
            <Skeleton variant='text' width='80%' height={16} />
          </StyledTableCell>
          <StyledTableCell sx={{ width: '90px' }}>
            <Skeleton variant='text' width={80} height={16} />
          </StyledTableCell>
          <StyledTableCell sx={{ width: '150px' }}>
            <Skeleton variant='text' width='75%' height={16} />
          </StyledTableCell>
        </StyledTableRow>
      </TableBody>
      <TableHead>
        <TableRow>
          <StyledHeaderCell>Agency Usage</StyledHeaderCell>
          <StyledHeaderCell>Management Price</StyledHeaderCell>
          <StyledHeaderCell colSpan={2}>Criticality</StyledHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <StyledTableRow>
          <StyledTableCell>
            <Skeleton variant='text' width={100} height={16} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant='text' width={90} height={16} />
          </StyledTableCell>
          <StyledTableCell colSpan={2}>
            <Skeleton variant='text' width='55%' height={16} />
          </StyledTableCell>
        </StyledTableRow>
      </TableBody>
    </StyledTable>
  );
};
